<template lang='slm'>
  form.text-left @submit.prevent='formSubmit'
    template v-if='item'
      button.d-none
      .form-group
        label Аудио
        .d-block
          audio ref='songModalAudio' controls='' @loadeddata='fillDuration'
            source :src='"/api/file/" + item.fileId' type='audio/mp3'
        admin-file-uploader v-model='item.fileId' @fileSelected='fileSelected'
      .form-group
        label Название
        input.form-control type='text' name='songTitle' v-model='item.title' v-validate='"required"'
        small.text-danger v-show="errors.has('songTitle')" {{ errors.first('songTitle') }}
</template>

<script>
import AdminFileUploader from '@/components/AdminFileUploader';

export default {
  name: 'AdminAlbumSongModalContent',
  components: { AdminFileUploader },
  data() {
    return {
      item: null,
    };
  },
  methods: {
    formSubmit() {
      this.$parent.confirm();
    },
    beforeShow({ album, song }) {
      this.item = this.$_removeImmutabitity(song);
      // eslint-disable-next-line no-underscore-dangle
      delete this.item.__typename;
      this.item.albumId = album.id;
    },
    fillDuration() {
      this.item.duration = Math.ceil(this.$refs.songModalAudio.duration);
    },
    fileSelected(file) {
      if (!this.item.title) {
        this.item.title = file.name;
      }
    },
  },
  computed: {
    modalContentData() {
      return this.item;
    },
  },
  mounted() {
    this.$on('beforeShow', this.beforeShow);
  },
  watch: {
    'item.fileId': function itemFileIdUpdated() {
      if (this.$refs.songModalAudio) {
        this.$refs.songModalAudio.load();
      }
    },
  },
};
</script>
